// extracted by mini-css-extract-plugin
export var categoryIcon = "_ch-5";
export var connectorContainer = "_ch-1";
export var connectorLine = "_ch-0";
export var minHeight0 = "_ch-6";
export var relativeUnitValueSelector = "_ch-2";
export var trifoldSelectorBody = "_ch-4";
export var trifoldSelectorList = "_ch-3";